import { render, staticRenderFns } from "./ContratoDetalhar.vue?vue&type=template&id=21bfb1bb&scoped=true&"
import script from "./ContratoDetalhar.vue?vue&type=script&lang=js&"
export * from "./ContratoDetalhar.vue?vue&type=script&lang=js&"
import style0 from "./ContratoDetalhar.vue?vue&type=style&index=0&id=21bfb1bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bfb1bb",
  null
  
)

export default component.exports